import { IRootState } from "../../store";

export const selectProductsFile = (state: IRootState) => state.xml.productsFile;

export const selectProductsFileLoading = (state: IRootState) =>
  state.xml.isProductsFileLoading;
